module.exports = __webpack_public_path__ + "static/img/davidmueller_circle150.21d470a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/experts/davidmueller_circle150.png
// module id = A7Uk
// module chunks = 0